import { format } from 'date-fns';

let DEFAULT_TIME = 313200000; // 1970-01-05 00:00:00.000
let MIN_TIME = 342000000; // 1970-01-05 08:00:00.000
// let MAX_TIME = 392400000; // 1970-01-05 22:00:00.000
let MAX_TIME = 399599999; // 1970-01-05 23:59:59.000

export let defaultDate = new Date(DEFAULT_TIME);
export let minDate = new Date(MIN_TIME);
export let maxDate = new Date(MAX_TIME);

let SECOND = 1000;
let MINUTES = SECOND * 60;
let HOUR = MINUTES * 60;
let DAY = HOUR * 24;
let THURSDAY = DAY * 0;
let FRIDAY = DAY * 1;
let SATURDAY = DAY * 2;
let SUNDAY = DAY * 3;
let MONDAY = DAY * 4;
let TUESDAY = DAY * 5;
let WEDNESDAY = DAY * 6;

export let SELECTION_TIMES = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];
export let SELECTION_MINUTES = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

export let ScheduleType = {
    PRIVATE: 'PRIVATE',
    CLASS: 'CLASS',
};

export let EventType = {
    SELECT: 'SELECT',
    CREATE: 'CREATE',
    MODIFY: 'MODIFY',
    DELETE: 'DELETE',
};

export const convertTimetableHeader = (hour) => {
    if (hour < 12) {
        return hour + ' AM';
    } else if (hour == 12) {
        return hour + ' PM';
    } else if (hour > 12) {
        var tmp = hour - 12;
        return tmp + ' PM';
    }
};

export const convertWday = (date, localizer) => {
    let wday = localizer.format(date, 'ddd').toUpperCase();
    switch (wday) {
        case 'SUN':
            return { en: wday, ko: '일' };
        case 'MON':
            return { en: wday, ko: '월' };
        case 'TUE':
            return { en: wday, ko: '화' };
        case 'WED':
            return { en: wday, ko: '수' };
        case 'THU':
            return { en: wday, ko: '목' };
        case 'FRI':
            return { en: wday, ko: '금' };
        case 'SAT':
            return { en: wday, ko: '토' };
    }
};

export const convertStringWday = (wday) => {
    switch (wday) {
        case 'SUN':
            return '일';
        case 'MON':
            return '월';
        case 'TUE':
            return '화';
        case 'WED':
            return '수';
        case 'THU':
            return '목';
        case 'FRI':
            return '금';
        case 'SAT':
            return '토';
    }
};

export const convertDttm2Dt = (dttm) => {
    return dttm.split('.')[0];
};

const paddingZero = (value) => {
    if (value < 10) {
        return '0' + value;
    } else {
        return value;
    }
};

export function convertTime(date) {
    return paddingZero(date.getHours()) + paddingZero(date.getMinutes());
}

export function convertDate(wday, time) {
    var timestamp = 0;
    switch (wday) {
        case 0:
            timestamp += SUNDAY;
            break;
        case 1:
            timestamp += MONDAY;
            break;
        case 2:
            timestamp += TUESDAY;
            break;
        case 3:
            timestamp += WEDNESDAY;
            break;
        case 4:
            timestamp += THURSDAY;
            break;
        case 5:
            timestamp += FRIDAY;
            break;
        case 6:
            timestamp += SATURDAY;
            break;
    }
    var hour = time.slice(0, 2);
    var minutes = time.slice(2, 4);
    timestamp += hour * HOUR;
    timestamp += minutes * MINUTES;
    timestamp -= 9 * HOUR;
    return new Date(timestamp);
}

export function date2ViewTime(date) {
    return paddingZero(date.getHours()) + ':' + paddingZero(date.getMinutes());
}

export function saveTime2ViewTime(saveTime) {
    return saveTime.slice(0, 2) + ':' + saveTime.slice(2, 4);
}

export function viewTime2SaveTime(time) {
    return time.replace(':', '');
}

export function date2ViewDate(date) {
    return date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6, 8);
}

export function viewDate2SaveDate(date) {
    return date.replaceAll('-', '');
}

export const stringDate2Millis = (stringDate) => {
    const date = new Date(stringDate);
    date.setHours(0);
    return date.getTime();
};

export const millis2StringDate = (millis, delimiter = '-') => {
    if (millis != undefined && millis != null && millis > 0) {
        const date = new Date(millis);
        const year = date.getFullYear();
        const month = paddingZero(date.getMonth() + 1);
        const day = paddingZero(date.getDate());
        return [year, month, day].join(delimiter);
    } else {
        return '';
    }
};

export const formatDateTimeString = (millis) => {
    if (millis != undefined && millis != null && millis > 0) {
        return format(new Date(millis), 'yyyy-MM-dd HH:mm');
    } else {
        return '';
    }
};

export const millis2Date = (millis) => {
    if (millis != undefined) {
        const date = new Date(millis);
        return date;
    } else {
        return null;
    }
};

export const date2Millis = (date) => {
    if (date != undefined) {
        return date.getTime();
    } else {
        return 0;
    }
};

/* ======================================================= */
export const WEEKDAY = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const WEEKDAY_TO_BASETIME = [
    '1970-01-04',
    '1970-01-05',
    '1970-01-06',
    '1970-01-07',
    '1970-01-08',
    '1970-01-09',
    '1970-01-10',
];
export const date2WeekdayCd = (date) => {
    return WEEKDAY[date.getDay()];
};
export const date2SaveTime = (date) => {
    return paddingZero(date.getHours()) + '' + paddingZero(date.getMinutes());
};
export const weekdayCdSaveTime2Date = (weekdayCd, saveTime) => {
    return new Date(WEEKDAY_TO_BASETIME[WEEKDAY.indexOf(weekdayCd)] + ' ' + saveTime2ViewTime(saveTime));
};
/* ======================================================= */
